// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"PageTitle_pageHeader__1UYE5","title":"PageTitle_title__3_pNK"};